export class OverdueMetrics {

  public overdueAndNotProcessedYet: number;
  public overdueAndPicked: number;
  public dueToday: number;
  public notOverdue: number;
  public blocked: number;

  public static fromDto(data: any): OverdueMetrics {
    if (!data) {
      return null;
    }

    const metrics = new OverdueMetrics();

    metrics.overdueAndNotProcessedYet = data.overdue_and_not_processed_yet;
    metrics.overdueAndPicked          = data.overdue_and_picked;
    metrics.dueToday                  = data.due_today;
    metrics.notOverdue                = data.not_overdue;
    metrics.blocked                   = data.blocked;

    return metrics;
  }
}
